import './style.scss'
import { Entry } from '../Entry'
import { useAppContext } from '../../contexts/AppContext'

export function EntryList() {
  const { state } = useAppContext()

  return (
    <div className='entry-list'>
      {state.entries.map((entry) => (
        <Entry key={entry.id} entry={entry} />
      ))}
    </div>
  )
}
